import { useActionless, useAppSelector } from 'redux/hooks'
import { SET_ACTIVE_STATE } from 'redux/active/actions/types'

import GlobalOverlayStack from 'components/elements/Overlay/GlobalOverlayStack'
import InteractionContainer from 'components/deckPage/interactions/InteractionContainer'

import styles from './interactionOverlay.module.scss'

const InteractionOverlay = () => {
  const interactionOverlay = useAppSelector(state => state.active.interactionOverlay)

  const [setActiveState] = useActionless(SET_ACTIVE_STATE)

  return (
    <GlobalOverlayStack open={interactionOverlay} onClose={() => setActiveState({ interactionOverlay: false })}>
      <InteractionContainer className={styles.content} />
    </GlobalOverlayStack>
  )
}

export default InteractionOverlay
